import React from "react";
import * as PhosphorIcons from "@phosphor-icons/react";
import { Trash, PencilSimple } from "@phosphor-icons/react";
import { ACTIVITY_COLORS, ACTIVITY_ICONS, fmtDateTime } from "../../lib/utils";

export default function Timeline({ activities, onEdit, onDelete }) {
  if (!activities?.length) {
    return (
      <div className="text-center py-10 text-gray-500 border border-dashed border-gray-300 rounded-lg" data-testid="timeline-empty">
        No activities yet. Log the first call, email or meeting.
      </div>
    );
  }
  return (
    <div data-testid="timeline">
      {activities.map((a) => {
        const iconName = ACTIVITY_ICONS[a.activity_type] || "Circle";
        const Icon = PhosphorIcons[iconName] || PhosphorIcons.Circle;
        const color = ACTIVITY_COLORS[a.activity_type] || "#6B7280";
        return (
          <div key={a.id} className="timeline-item group" data-testid={`timeline-item-${a.id}`}>
            <div
              className="absolute left-0 top-1 w-8 h-8 rounded-full flex items-center justify-center"
              style={{ background: `${color}18`, border: `2px solid ${color}` }}
            >
              <Icon size={16} weight="bold" style={{ color }} />
            </div>
            <div className="bg-white border border-gray-200 rounded-lg p-4 hover:border-[#1A3A21] transition-colors">
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-xs font-bold uppercase tracking-wider" style={{ color }}>
                    {a.activity_type.replace("_", " ")}
                  </span>
                  {a.outcome && (
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-700">
                      {a.outcome}
                    </span>
                  )}
                  {a.status === "Completed" && (
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-green-50 text-green-700 border border-green-200">
                      Completed
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  <div className="text-xs text-gray-500">{fmtDateTime(a.activity_date)}</div>
                  {onEdit && (
                    <button onClick={() => onEdit(a)} data-testid={`edit-activity-${a.id}`}
                      className="opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-gray-100 text-gray-400 hover:text-[#1A3A21]">
                      <PencilSimple size={14} />
                    </button>
                  )}
                  {onDelete && (
                    <button onClick={() => onDelete(a)} data-testid={`delete-activity-${a.id}`}
                      className="opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-red-50 text-gray-400 hover:text-red-600">
                      <Trash size={14} />
                    </button>
                  )}
                </div>
              </div>
              <div onClick={() => onEdit?.(a)} className={onEdit ? "cursor-pointer" : ""}>
                <div className="mt-1 text-sm font-semibold text-gray-900 hover:text-[#1A3A21]">{a.title}</div>
                {a.description && (
                  <div className="mt-1 text-sm text-gray-600 whitespace-pre-line">{a.description}</div>
                )}
              </div>
              {a.order_amount ? (
                <div className="mt-2 text-xs text-[#1A3A21] font-semibold">
                  Order: €{Number(a.order_amount).toLocaleString()}
                </div>
              ) : null}
              {a.sample_details && (
                <div className="mt-2 text-xs text-gray-700">Samples: {a.sample_details}</div>
              )}
              {a.next_action && (
                <div className="mt-2 text-xs text-gray-700">Next action: {a.next_action}</div>
              )}
              {a.next_follow_up_date && (
                <div className="mt-1 text-xs text-[#E1A104] font-semibold">
                  Follow-up: {fmtDateTime(a.next_follow_up_date)}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
